/** 集团大屏模拟数据。无业务接口的概览模块保留演示，绝不覆盖真实接口失败。
 * 原 model.js 的模拟工厂迁移至此；其他业务页继续使用原有模拟口径。 */
// 原演示快照的独立副本；不再依赖项目子屏数据工厂，后续修改仅影响本大屏。
import { powerDuty, dutyStates, closedPowerCount } from './power/duty'
const MOCK_PROJECTS = [
  {
    id: '1000107',
    name: '南都广场',
    shortName: '南都广场',
    business: 'office',
    businessName: '商办',
    scene: 'nandu',
    hasPv: true,
    snapshot: {
      energy: {
        total: 286600,
        tenant: 218600,
        common: 68000,
        gridImport: 270800,
        tenantToday: 12480,
        commonToday: 3940,
        projectToday: 16420,
        waterToday: 186,
        tenantWater: 3280,
        indoor: 153020,
        airConditioning: 65580,
        indoorPercent: 70,
        airConditioningPercent: 30
      },
      devices: {
        total: 584,
        online: 570,
        offline: 14,
        airConditioning: {
          total: 216,
          running: 148,
          standby: 62,
          offline: 6
        }
      },
      finance: {
        receivable: 264500,
        received: 253920,
        balance: 128640
      },
      photovoltaic: {
        generated: 18600,
        selfUse: 15800,
        exported: 2800
      }
    }
  },
  {
    id: '1000171',
    name: '吴淞江新邻荟',
    shortName: '吴淞江新邻荟',
    business: 'office',
    businessName: '商办',
    scene: 'wusong',
    hasPv: false,
    snapshot: {
      energy: {
        total: 212084,
        tenant: 161764,
        common: 50320,
        gridImport: 212084,
        tenantToday: 9235,
        commonToday: 2916,
        projectToday: 12151,
        waterToday: 138,
        tenantWater: 2427,
        indoor: 113235,
        airConditioning: 48529,
        indoorPercent: 70,
        airConditioningPercent: 30
      },
      devices: {
        total: 482,
        online: 474,
        offline: 8,
        airConditioning: {
          total: 180,
          running: 126,
          standby: 51,
          offline: 3
        }
      },
      finance: {
        receivable: 195730,
        received: 184766,
        balance: 95194
      },
      photovoltaic: {
        generated: 0,
        selfUse: 0,
        exported: 0
      }
    }
  },
  {
    id: '1000175',
    name: '苏旺商务中心广场',
    shortName: '苏旺商务中心',
    business: 'office',
    businessName: '商办',
    scene: 'suwang',
    hasPv: false,
    snapshot: {
      energy: {
        total: 521612,
        tenant: 397852,
        common: 123760,
        gridImport: 521612,
        tenantToday: 22714,
        commonToday: 7171,
        projectToday: 29885,
        waterToday: 339,
        tenantWater: 5970,
        indoor: 278496,
        airConditioning: 119356,
        indoorPercent: 70,
        airConditioningPercent: 30
      },
      devices: {
        total: 968,
        online: 950,
        offline: 18,
        airConditioning: {
          total: 368,
          running: 255,
          standby: 104,
          offline: 9
        }
      },
      finance: {
        receivable: 481390,
        received: 450571,
        balance: 234125
      },
      photovoltaic: {
        generated: 0,
        selfUse: 0,
        exported: 0
      }
    }
  },
  {
    id: '1000178',
    name: '经开-机器人产业园',
    shortName: '机器人产业园',
    business: 'industrial',
    businessName: '产业园',
    scene: null,
    hasPv: false,
    snapshot: {
      energy: {
        total: 418436,
        tenant: 319156,
        common: 99280,
        gridImport: 418436,
        tenantToday: 18221,
        commonToday: 5752,
        projectToday: 23973,
        waterToday: 272,
        tenantWater: 4789,
        indoor: 223409,
        airConditioning: 95747,
        indoorPercent: 70,
        airConditioningPercent: 30
      },
      devices: {
        total: 742,
        online: 722,
        offline: 20,
        airConditioning: {
          total: 254,
          running: 175,
          standby: 72,
          offline: 7
        }
      },
      finance: {
        receivable: 386170,
        received: 370312,
        balance: 187814
      },
      photovoltaic: {
        generated: 0,
        selfUse: 0,
        exported: 0
      }
    }
  },
  {
    id: '1000183',
    name: '塔韵商务广场',
    shortName: '塔韵商务广场',
    business: 'office',
    businessName: '商办',
    scene: 'tayun',
    hasPv: false,
    snapshot: {
      energy: {
        total: 174826,
        tenant: 133346,
        common: 41480,
        gridImport: 174826,
        tenantToday: 7613,
        commonToday: 2403,
        projectToday: 10016,
        waterToday: 113,
        tenantWater: 2001,
        indoor: 93342,
        airConditioning: 40004,
        indoorPercent: 70,
        airConditioningPercent: 30
      },
      devices: {
        total: 376,
        online: 371,
        offline: 5,
        airConditioning: {
          total: 142,
          running: 99,
          standby: 41,
          offline: 2
        }
      },
      finance: {
        receivable: 161345,
        received: 154720,
        balance: 78470
      },
      photovoltaic: {
        generated: 0,
        selfUse: 0,
        exported: 0
      }
    }
  },
  {
    id: '1000198',
    name: 'OPC人工智能产业园',
    shortName: 'OPC人工智能产业园',
    business: 'industrial',
    businessName: '产业园',
    scene: null,
    hasPv: false,
    snapshot: {
      energy: {
        total: 384044,
        tenant: 292924,
        common: 91120,
        gridImport: 384044,
        tenantToday: 16723,
        commonToday: 5280,
        projectToday: 22003,
        waterToday: 249,
        tenantWater: 4395,
        indoor: 205047,
        airConditioning: 87877,
        indoorPercent: 70,
        airConditioningPercent: 30
      },
      devices: {
        total: 736,
        online: 726,
        offline: 10,
        airConditioning: {
          total: 296,
          running: 207,
          standby: 85,
          offline: 4
        }
      },
      finance: {
        receivable: 354430,
        received: 339876,
        balance: 172378
      },
      photovoltaic: {
        generated: 0,
        selfUse: 0,
        exported: 0
      }
    }
  }
]

export const PERIODS = [{ id: 'month', label: '2026年09月', factor: 1 }, { id: 'last', label: '2026年08月', factor: 0.93 }, { id: 'year', label: '2026年累计', factor: 8.3 }]
// Anchors identify six illustrative building clusters; they are not geographic locations.
const anchors = [[52, 38], [51, 61], [80, 47], [23, 65], [79, 72], [24, 36]]
export function createPortfolio () {
  return MOCK_PROJECTS.map((p, i) => ({
    ...p,
    snapshot: JSON.parse(JSON.stringify(p.snapshot)),
    anchor: anchors[i],
    ops: {
      rooms: [3, 2, 5, 4, 2, 4][i],
      transformers: [6, 4, 10, 8, 4, 8][i],
      capacity: [8, 5, 14, 12, 5, 10][i],
      load: [0.84, 0.63, 1.48, 1.27, 0.51, 1.09][i],
      health: [96.4, 97.2, 98.1, 96.8, 98.7, 97.4][i],
      closed: [42, 28, 51, 47, 23, 38][i],
      open: [2, 1, 2, 1, 1, 1][i],
      arrears: [8, 4, 12, 9, 3, 7][i],
      cop: [4.72, 4.61, 4.85, 4.58, 4.79, 4.68][i],
      comfort: [98.1, 97.8, 98.6, 97.4, 98.3, 98.2][i],
      lights: [320, 240, 480, 420, 180, 360][i],
      lightOn: [228, 162, 350, 294, 127, 251][i],
      lightFault: [2, 1, 3, 2, 0, 2][i],
      lightCoverage: [94.5, 95.2, 97.1, 94.8, 96.1, 95.7][i],
      spaces: [460, 320, 680, 420, 260, 520][i],
      parkingUsed: [328, 216, 486, 295, 187, 364][i],
      parkingIncome: [96200, 62800, 148600, 78900, 51600, 106800][i],
      plugs: [32, 24, 48, 36, 20, 40][i],
      charging: [12, 8, 19, 14, 7, 15][i],
      chargeFault: [0, 0, 1, 1, 0, 0][i],
      chargeKwh: [28640, 21860, 41280, 32640, 16420, 36780][i],
      chargeIncome: [34368, 26232, 49536, 39168, 19704, 44136][i]
    }
  }))
}
export const num = (v, digits = 0) => Number(v || 0).toLocaleString('zh-CN', { minimumFractionDigits: digits, maximumFractionDigits: digits })
export const rate = (a, b) => b ? a / b * 100 : 0
export function aggregatePortfolio (projects, period = 'month') {
  const factor = (PERIODS.find(p => p.id === period) || PERIODS[0]).factor
  const s = {}
  ;['energy', 'finance', 'photovoltaic'].forEach(section => {
    s[section] = {}
    Object.keys(MOCK_PROJECTS[0].snapshot[section]).forEach(key => { s[section][key] = projects.reduce((n, p) => n + p.snapshot[section][key], 0) })
  })
  s.devices = { airConditioning: {} }
  ;['total', 'online', 'offline'].forEach(key => { s.devices[key] = projects.reduce((n, p) => n + p.snapshot.devices[key], 0) })
  ;['total', 'running', 'standby', 'offline'].forEach(key => { s.devices.airConditioning[key] = projects.reduce((n, p) => n + p.snapshot.devices.airConditioning[key], 0) })
  const sum = key => projects.reduce((n, p) => n + p.ops[key], 0)
  const average = key => projects.length ? sum(key) / projects.length : 0
  const m = { count: projects.length, devices: s.devices.total, online: s.devices.online, offline: s.devices.offline, ac: s.devices.airConditioning.total, acRun: s.devices.airConditioning.running, acStandby: s.devices.airConditioning.standby, acOffline: s.devices.airConditioning.offline, water: Math.round(s.energy.tenantWater * factor), pv: Math.round(s.photovoltaic.generated * factor), self: Math.round(s.photovoltaic.selfUse * factor), exported: Math.round(s.photovoltaic.exported * factor), kwh: Math.round(s.energy.total * factor), tenant: Math.round(s.energy.tenant * factor), fees: Math.round(s.finance.receivable * factor), received: Math.round(s.finance.received * factor), balance: s.finance.balance }
  // Round at project level first so the detail table always adds up to the group KPI.
  ;[['water', 'energy', 'tenantWater'], ['kwh', 'energy', 'total'], ['tenant', 'energy', 'tenant'], ['fees', 'finance', 'receivable'], ['received', 'finance', 'received']].forEach(([key, section, field]) => {
    m[key] = projects.reduce((total, p) => total + Math.round(p.snapshot[section][field] * factor), 0)
  })
  m.grid = m.kwh - m.self
  m.common = m.kwh - m.tenant
  m.airKwh = projects.reduce((total, p) => total + Math.round(Math.round(p.snapshot.energy.tenant * factor) * 0.3), 0)
  m.lightKwh = projects.reduce((total, p) => total + Math.round((Math.round(p.snapshot.energy.total * factor) - Math.round(p.snapshot.energy.tenant * factor)) * 0.18), 0)
  m.outstanding = m.fees - m.received
  m.collection = rate(m.received, m.fees)
  m.selfRate = rate(m.self, m.pv)
  m.greenRate = rate(m.self, m.kwh)
  m.onlineRate = rate(m.online, m.devices)
  ;['rooms', 'transformers', 'capacity', 'load', 'closed', 'open', 'arrears', 'lights', 'lightOn', 'lightFault', 'spaces', 'parkingUsed', 'plugs', 'charging', 'chargeFault'].forEach(key => { m[key] = sum(key) })
  ;['parkingIncome', 'chargeIncome', 'chargeKwh'].forEach(key => { m[key] = projects.reduce((total, p) => total + Math.round(p.ops[key] * factor), 0) })
  m.visits = projects.reduce((total, p) => total + Math.round(Math.round(p.ops.parkingIncome * factor) / 8), 0)
  ;['health', 'cop', 'comfort', 'lightCoverage'].forEach(key => { m[key] = average(key) })
  m.lightOff = m.lights - m.lightOn - m.lightFault
  m.chargeIdle = m.plugs - m.charging - m.chargeFault
  m.revenue = m.received + m.parkingIncome + m.chargeIncome
  m.closed += closedPowerCount(projects)
  m.risk = m.open
  m.pvPower = projects.some(p => p.hasPv) ? 0.026 : 0
  return m
}

// 模拟数据：总览专用停车预览，金额单位元。
// 仅映射可确认归属的三个项目。旺山不在六项目范围内，不移植其收入。
export function overviewParkingPreview (projects, period = 'month') {
  const examples = { 1000107: [5200, 24600], 1000178: [1800, 4600], 1000198: [15100, 15900] }
  const factor = { month: 1, last: 0.94, year: 9.4 }[period] || 1
  return projects.filter(p => examples[p.id]).map(p => {
    const [temporary, monthly] = examples[p.id].map(value => Math.round(value * factor))
    return { id: p.id, name: p.shortName, temporary, monthly, total: temporary + monthly }
  })
}
// 集中值守共用的两条轻微演示事项：总览、配电页、数量与项目筛选共用同一来源。
export function overviewAlerts (projects) {
  const examples = [
    { id: 'overview-comm', projectId: '1000107', icon: 'el-icon-connection', title: '采集数据短时延迟', level: '提示', time: '10:19', status: '待排查', detail: '演示场景：一处采集点上报延迟约 3 分钟，暂未发现供电中断。建议值班人员核查网关网络及下一次上报，恢复后记录复核结果。' },
    { id: 'overview-light', projectId: '1000178', icon: 'el-icon-sunny', title: '照明定时策略待复核', level: '提示', time: '10:20', status: '处理中', detail: '演示场景：公共区域照明计划与当前开放时间存在 15 分钟偏差。建议核对营业安排后调整定时策略，并复核次日执行情况。' }
  ]
  return examples.filter(e => projects.some(p => p.id === e.projectId) && !(e.id === 'overview-comm' && powerDuty.step === 3)).map(e => ({ ...e, status: e.id === 'overview-comm' ? dutyStates[powerDuty.step] : e.status, projectName: projects.find(p => p.id === e.projectId).shortName }))
}

// 充电演示按原项目模型生成，顶栏、业务明细与底部卡片共用同一金额。
export function overviewChargingPreview (projects, period = 'month') {
  return projects.map(p => {
    const model = aggregatePortfolio([p], period)
    const energyFee = Math.round(model.chargeIncome * 0.75)
    return { id: p.id, name: p.shortName, kwh: model.chargeKwh, energyFee, serviceFee: model.chargeIncome - energyFee, total: model.chargeIncome }
  })
}
